var checkUndefined = function (value) {
    return value !== undefined ? value : "";
};
export default checkUndefined;
